import classNames from "classnames";
import * as React from "react";

import styles from "./DetailActions.module.css";

export interface DetailActionsProps {
  /** Pinned left: the reversible control, such as an enable switch. */
  start?: React.ReactNode;
  /** Pinned right: notes and buttons, with the destructive one last. */
  children?: React.ReactNode;
  className?: string;
}

/**
 * The row of lifecycle controls at the top of a detail page: a switch on the
 * left, Edit and Delete on the right.
 */
export function DetailActions({
  start,
  children,
  className,
}: DetailActionsProps) {
  return (
    <div className={classNames(styles.row, className)}>
      {start}
      <div className={styles.spacer} />
      {children}
    </div>
  );
}
